export const GOOGLE_API_ORIGIN = 'https://maps.googleapis.com';
export const GOOGLE_API_MAP_PATH = '/maps/api/js';
export const GOOGLE_API_MAP_QUERY = '?key={0}&v=3.exp';
export const GOOGLE_API_MAP_SCRIPT_PATH = `${GOOGLE_API_ORIGIN}${GOOGLE_API_MAP_PATH}${GOOGLE_API_MAP_QUERY}`;
export const GOOGLE_API_MAP_ZOOM_DEFAULT = 7;
export const GOOGLE_API_MAP_ZOOM_MAX = 18;
export const GOOGLE_API_MAP_CENTER = { lat: 54.559322, lng: -4.174804 };
export const GOOGLE_MARKER_SIZE = 66;
export const GOOGLE_MARKER_TOP_MARGIN = 10;
export const GOOGLE_INFO_WINDOW_MARGIN = 20;
export const GOOGLE_MIN_CLUSTER_SIZE = 4;

export const GOOGLE_DEFAULT_OPTIONS = {
  disableDefaultUI: false,
  draggable: true,
  scrollwheel: false,
  panControl: true,
  disableDoubleClickZoom: false,
  gestureHandling: 'cooperative',
  mapTypeControl: false,
  defaultZoom: GOOGLE_API_MAP_ZOOM_DEFAULT,
  zoomMax: GOOGLE_API_MAP_ZOOM_MAX,
  zoomControlOptions: {
    position: 3, // google.maps.ControlPosition.TOP_RIGHT
  },
  fullscreenControl: false,
  fullscreenControlOptions: {
    position: 9,
  },
  streetViewControl: false,
  styles: [
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{
        visibility: 'off',
      }],
    },
  ],
};

export const GOOGLE_DEFAULT_PIN = {
  path: 'M50,15c-16.5-0.2-30,13.1-30.1,29.6C19.9,60.9,50,100,50,100s30.1-39.1,30.1-55.4C80,28.1,66.5,14.9,50,15z M57.3,52.5c-4.3,4.1-11,4.1-15.3,0c-4.2-4.1-4.3-10.7-0.2-14.9c0.1-0.1,0.1-0.1,0.2-0.2c4.3-4.1,11-4.1,15.3,0 c4.2,4.1,4.3,10.7,0.2,14.9C57.4,52.4,57.3,52.5,57.3,52.5z',
  fillColor: '#01437d',
  strokeOpacity: 0,
  anchor: { x: 50, y: 100 },
  fillOpacity: 1,
  scale: 0.5,
};

export const GOOGLE_DEFAULT_CLUSTER = `data:image/svg+xml;charset=UTF-8;base64,${btoa(`<?xml version="1.0" encoding="UTF-8"?>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
    <style type="text/css">.st0{fill:#01437D;}</style>
    <g>
      <rect x="15" y="15" class="st0" width="70" height="70"/>
      <polygon class="st0" points="60.8,85 49.9,100 39.1,85"/>
    </g>
  </svg>`)}`;

export const GOOGLE_GREY_PIN = `data:image/svg+xml;charset=UTF-8;base64,${btoa(`<?xml version="1.0" encoding="UTF-8"?>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve">
    <path class="st0" style="opacity:0.3;" d="M30,56.1c4.2,0,7.5-0.9,7.5-2s-3.4-2-7.5-2s-7.5,0.9-7.5,2S25.9,56.1,30,56.1z"/>
    <path class="st1" fill="#FFFFFF" d="M30.4,3.1c-9.7,0-17.6,7.9-17.6,17.6c0,7.1,4.2,13.4,10.8,16.1l4.8,11.8h3.9l4.8-11.8C43.6,34,48,27.6,48,20.6
      C48,11,40.2,3.1,30.4,3.1z"/>
    <path class="st2" fill="#6b6b6a" d="M30.4,4.1c-9.1,0-16.5,7.4-16.5,16.5c0,6.8,4.1,12.8,10.5,15.4l4.7,11.5h2.5L36.2,36
      c6.4-2.5,10.7-8.6,10.7-15.4C46.9,11.5,39.5,4.1,30.4,4.1z M30.3,27.9c-4.1,0-7.5-3.3-7.5-7.5c0-4.1,3.4-7.6,7.5-7.6
      s7.5,3.3,7.5,7.5S34.5,27.9,30.3,27.9z"/>
  </svg>`)}`;

export const GOOGLE_CLUSTER_SIZES = [
  42,
  48,
  54,
  60,
  66,
];
